export default "__VITE_ASSET__7DJcrbsC__"